import { CustomSegmentationFields } from "@appetize/iw-common/interfaces/featureFlags/featureFlags";
import { FeatureFlagsState } from "./interfaces";

/**
 * Returns all feature flags in app state
 * @param state
 * @returns {{FeatureFlagsState}}
 */
export const getFeatureFlags = (state): FeatureFlagsState => {
  return state.featureFlags;
};
/**
 * Returns a function that returns a flag status from app state, if flag is not in app state then it returns false
 * @param state
 * @param getters
 * @returns {{Function}}
 */
export const getFeatureFlagById =
  (state, getters) =>
  (flagId): { [key: string]: boolean } => {
    return getters.getFeatureFlags[flagId] ? getters.getFeatureFlags[flagId] : false;
  };
/**
 * Returms all custom segmentation fields
 * @param state
 * @param getters
 * @param rootState
 * @param rootGetters
 * @returns {{CustomSegmentationFields}}
 */
export const getCustomSegmentationFields = (state, getters, rootState, rootGetters): CustomSegmentationFields => {
  const venueId = `${rootGetters["venue/getActiveVenue"] || ""}`;
  const vendorId = `${rootGetters["vendor/getActiveVendor"]?.id || ""}`;

  return {
    venueId,
    vendorId
  };
};
